import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';

// Lazy load all components to reduce initial bundle size
const AgeVerification = lazy(() => import('./components/AgeVerification'));
const CookieConsent = lazy(() => import('./components/CookieConsent'));
const Guides = lazy(() => import('./pages/Guides'));
const News = lazy(() => import('./pages/News'));
const Reviews = lazy(() => import('./pages/Reviews'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const ResponsibleGaming = lazy(() => import('./pages/ResponsibleGaming'));
const NewsArticle1 = lazy(() => import('./pages/NewsArticle1'));
const NewsArticle2 = lazy(() => import('./pages/NewsArticle2'));
const NewsArticle3 = lazy(() => import('./pages/NewsArticle3'));
const NewsArticle4 = lazy(() => import('./pages/NewsArticle4'));
const NewsArticle5 = lazy(() => import('./pages/NewsArticle5'));
const NewsArticle6 = lazy(() => import('./pages/NewsArticle6'));
const NewsArticle7 = lazy(() => import('./pages/NewsArticle7'));
const NewsArticle8 = lazy(() => import('./pages/NewsArticle8'));
const NewsArticle9 = lazy(() => import('./pages/NewsArticle9'));
const GettingStarted = lazy(() => import('./pages/guides/GettingStarted'));
const UKGamblingLicenses = lazy(() => import('./pages/guides/UKGamblingLicenses'));
const ChooseBestCasino = lazy(() => import('./pages/guides/ChooseBestCasino'));
const WelcomeBonuses = lazy(() => import('./pages/guides/WelcomeBonuses'));
const PaymentMethods = lazy(() => import('./pages/guides/PaymentMethods'));
const WithdrawalTimes = lazy(() => import('./pages/guides/WithdrawalTimes'));
const ResponsibleGambling = lazy(() => import('./pages/guides/ResponsibleGambling'));
const WageringRequirements = lazy(() => import('./pages/guides/WageringRequirements'));
const MobileCasinoGaming = lazy(() => import('./pages/guides/MobileCasinoGaming'));
const CasinoCasino = lazy(() => import('./pages/reviews/CasinoCasino'));
const Magicred = lazy(() => import('./pages/reviews/Magicred'));
const AllBritish = lazy(() => import('./pages/reviews/AllBritish'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={null}>
        <AgeVerification />
        <CookieConsent />
      </Suspense>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/guides" element={<Guides />} />
        <Route path="/guides/getting-started" element={<GettingStarted />} />
        <Route path="/guides/uk-gambling-licenses" element={<UKGamblingLicenses />} />
        <Route path="/guides/choose-best-casino" element={<ChooseBestCasino />} />
        <Route path="/guides/welcome-bonuses" element={<WelcomeBonuses />} />
        <Route path="/guides/payment-methods" element={<PaymentMethods />} />
        <Route path="/guides/withdrawal-times" element={<WithdrawalTimes />} />
        <Route path="/guides/responsible-gambling" element={<ResponsibleGambling />} />
        <Route path="/guides/wagering-requirements" element={<WageringRequirements />} />
        <Route path="/guides/mobile-casino-gaming" element={<MobileCasinoGaming />} />
        <Route path="/news" element={<News />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/reviews/casino-casino" element={<CasinoCasino />} />
        <Route path="/reviews/magicred" element={<Magicred />} />
        <Route path="/reviews/all-british" element={<AllBritish />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        <Route path="/news/new-uk-gambling-regulations-2025" element={<NewsArticle1 />} />
        <Route path="/news/best-payment-methods-uk-casinos" element={<NewsArticle2 />} />
        <Route path="/news/understanding-wagering-requirements" element={<NewsArticle3 />} />
        <Route path="/news/uk-casino-market-trends-2025" element={<NewsArticle4 />} />
        <Route path="/news/live-dealer-games-popularity" element={<NewsArticle5 />} />
        <Route path="/news/cryptocurrency-casinos-uk" element={<NewsArticle6 />} />
        <Route path="/news/responsible-gambling-tools-update" element={<NewsArticle7 />} />
        <Route path="/news/slot-game-rtp-explained" element={<NewsArticle8 />} />
        <Route path="/news/casino-bonus-terms-changes" element={<NewsArticle9 />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
